export default "__VITE_ASSET__8057513b__"